import { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { Box, Flex } from "@otrium/core";
import { Sticky } from "src/atoms/Sticky";
import { theme } from "src/theme";

const initialState: {
  container: Record<string, string>;
  inner: Record<string, string>;
} = {
  container: {},
  inner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    gap: "16px",
  },
};

const StickyDesktopFilter = ({
  checkIsFilterSticky,
  children,
}: {
  checkIsFilterSticky: (value: boolean) => void;
  children: ReactNode;
}): JSX.Element => {
  const [styles, setStyles] = useState(initialState);
  const [isSticky, setSticky] = useState(false);

  const onChangeMode = useCallback(
    (mode: any) => {
      if (mode) {
        setStyles({
          inner: {
            ...initialState.inner,
            maxWidth: "1264px",
            margin: "0 auto",
            padding: "0 20px",
          },
          container: {
            padding: "16px 0",
            background: "white",
          },
        });
      } else {
        setStyles(initialState);
      }
    },
    [setStyles]
  );

  const { container: containerStyles, inner: innerStyles } = styles;
  const contentRef = useRef<HTMLDivElement>(null);
  const [offsetTop, setOffsetTop] = useState<number | null>(null);
  useEffect(() => {
    const offset = contentRef?.current?.getBoundingClientRect()?.top;
    if (offset) {
      setOffsetTop(offset + window.pageYOffset);
    }
  }, [contentRef, offsetTop, setOffsetTop]);

  const handleScroll = useCallback(() => {
    if (!offsetTop) {
      return;
    }

    const stickyFiltersOffset = window.pageYOffset >= offsetTop - 45;
    checkIsFilterSticky(stickyFiltersOffset);
    setSticky(stickyFiltersOffset);
  }, [offsetTop, checkIsFilterSticky]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <>
      {offsetTop !== null && offsetTop > 0 && isSticky ? (
        <Sticky
          offsetTop={-offsetTop}
          onChange={onChangeMode}
          top={63}
          boxshadowMode={"down"}
        >
          <Box sx={{ ...containerStyles }}>
            <Box sx={{ ...innerStyles }}>{children}</Box>
          </Box>
        </Sticky>
      ) : (
        <Flex
          justifyContent="space-between"
          ref={contentRef}
          gap={theme.space.space16}
          pb="space32"
          px={["space16", "space16", "space16", "space16", "space0"]}
        >
          {children}
        </Flex>
      )}
    </>
  );
};
export { StickyDesktopFilter };
